import { dequeueItem } from "store/alertSlice";
import { useCreateAlertMutation } from "services/alert";
import { AlertType, AlertName } from "helpers/alert-type";
import useQueueProcessor from "./useQueueProcessor";
import { handleError } from "helpers/sentry";
import { ClientErrorTypes } from "globals/enums";

const useAlertUploader = () => {
  const [createAlert] = useCreateAlertMutation();
  const queueSelector = (state: any) => state.alertQueue;

  const uploadAction = async (item: any) => {
    const keepalive = item?.alert_type_id === AlertType[AlertName.CandidateOffline].id;
    const executeUpload = () =>
      keepalive
        ? createAlert({ ...item, keepalive: true }).unwrap()
        : createAlert(item).unwrap();

    let attempt = 0;
    while (attempt < 3) {
      try {
        attempt += 1;
        await executeUpload();
        return;
      } catch (error) {
        console.log(`Alert API failed for attempt ${attempt}: ${item?.description ?? "unknown"}`, error)
        if (attempt < 3) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }
    }

    throw new Error(`Alert API failed: ${item?.description ?? "unknown"}`);
  };

  const uploadError = (error) => {
    handleError(error, ClientErrorTypes.AlertUploadError)
  }

  useQueueProcessor(queueSelector, dequeueItem, uploadAction, uploadError);
};

export default useAlertUploader;
